import router from '@/router'
import axios from 'axios' // 引入
import { ElLoading, ElMessage, ElNotification } from 'element-plus'
import { useStorage } from '@vueuse/core'

let nologin = [
    '/sqmv1/aa/a1',
    '/sqmv1/aa/a2',
    '/sqmv1/aa/a3',
    '/sqmv1/aa/a5',
    '/sqmv1/jj/j57',
    '/sqmv1/aa/a6',
    '/sqmv1/aa/a100'
]
let token = ''
// 这一步的目的是判断出当前是开发环境还是生成环境，方法不止一种，达到目的就行
// if(process.env.NODE_ENV=='development'){
//   baseURL=''
// }else{
//   baseURL=''
// }
// const store = useIndexSore()
// const { dsjToken } = storeToRefs(store)
const config = {
    baseURL: process.env.VUE_APP_BASE_API,
    // 因为跨域了，所以这里如果写的话会自动拼接，会有两份，所以隐藏了
    timeout: 60000 // 设置最大请求时间
}
const _axios = axios.create(config)

// /* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    config => {
        // 如果有需要在这里开启请求时的loading动画效果
        // config.headers.Authorization = getToken  //添加token,需要结合自己的实际情况添加，

        return config
    },
    err => Promise.reject(err)
)

// 封装post,get方法
// 按理来说应该也可以封装其他的方法
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            token = useStorage('token').value
            if (nologin.includes(url) === false) {
                if (!token) {
                    ElNotification({
                        message: '还未登录，请先登录',
                        type: 'error'
                    })
                    // window.localStorage.removeItem('token')
                    let isp_key = useStorage('isp_key').value
                    if (isp_key) {
                        router.push('/home' + isp_key)
                    } else {
                        router.push('/home')
                    }
                    return false
                }
            }
            _axios({
                url,
                params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8', token: token },
                method: 'GET'
            })
                .then(res => {
                    resolve(res.data)
                    return res
                })
                .catch(error => {
                    // if (error.response.data.code == 401 || error.response.data.code == 402) {
                    //   console.log("+++++++++++++777777777777777777777777777++++++++++++++++++")
                    //   ElNotification({
                    //     message: error.response.data.result,
                    //     type: 'error'
                    //   })
                    //   window.localStorage.removeItem('token')
                    //   router.push('/home')
                    //   return false
                    // }
                    // return false
                })
        })
    },
    post(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            token = useStorage('token').value

            if (nologin.includes(url) === false) {
                if (!token) {
                    ElNotification({
                        message: '还未登录，请先登录',
                        type: 'error'
                    })
                    // window.localStorage.removeItem('token')
                    // router.push('/home')
                    let isp_key = useStorage('isp_key').value
                    if (isp_key) {
                        router.push('/home' + isp_key)
                    } else {
                        router.push('/home')
                    }
                    return false
                }
            }
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8', token: token },
                method: 'POST'
            })
                .then(res => {
                    resolve(res.data)
                    return res
                })
                .catch(error => {
                    // if (error.response.data.code == 401 || error.response.data.code == 402 ) {
                    //     window.localStorage.removeItem('token')
                    // }
                    // router.push('/home')  //先注释
                })
        })
    },
    uploadXls: function (url, params) {
        return new Promise((resolve, reject) => {
            token = useStorage('token').value
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'multipart/form-data', token: token },
                method: 'POST'
            })
                .then(res => {
                    resolve(res.data)
                    return res
                })
                .catch(error => {
                    // console.log('请求网络失败11', error)
                    // if (error.response.data.code == 401 || error.response.data.code == 402) {
                    //   window.localStorage.removeItem('token')
                    // }
                })
        })
    },
    //上传文件
    uploads(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            token = useStorage('token').value
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'multipart/form-data', token: token },
                method: 'POST'
            })
                .then(res => {
                    resolve(res.data)
                    return res
                })
                .catch(error => {
                    // console.log('请求网络失败11', error)
                    // if (error.response.data.code == 401 || error.response.data.code == 402) {
                    //   window.localStorage.removeItem('token')
                    // }
                    // router.push('/home')    //先注释
                })
        })
    },
    // 文件下载（blob）
    download(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            token = useStorage('token').value
            if (nologin.includes(url) === false) {
                if (!token) {
                    ElNotification({
                        message: '还未登录，请先登录',
                        type: 'error'
                    })
                    let isp_key = useStorage('isp_key').value
                    if (isp_key) {
                        router.push('/home' + isp_key)
                    } else {
                        router.push('/home')
                    }
                    return false
                }
            }
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8', token: token },
                method: 'POST',
                responseType: 'blob'
            })
                .then(res => {
                    resolve(res)
                    return res
                })
                .catch(error => {})
        })
    }
}

// /* 请求之后的操作 */
_axios.interceptors.response.use(
    res => {
        // 在这里关闭请求时的loading动画效果
        // 这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写
        // 一定结合自己的后端的返回代码进行操作

        // if (res.data.code == 9999) {
        //   console.log("===================== 捕捉错误信息 ======================")
        //   console.log(res)
        //   console.log("===================== 捕捉错误信息 ======================")
        //   ElNotification({
        //     message: "本地网络延迟，请尝试刷新页面",
        //     type: 'error'
        //   })
        // }
        return res
    },
    err => {
        if (err) {
            // 在这里关闭请求时的loading动画效果   //先注释
            if (err.response.data.code == 402) {
                ElNotification({
                    message: err.response.data.msg,
                    type: 'error'
                })
                // window.localStorage.removeItem('token')
                useStorage('token').value = ''
                let isp_key = useStorage('isp_key').value

                if (isp_key) {
                    router.push('/home' + isp_key)
                } else {
                    router.push('/home')
                }

                // router.push('/home')
            }
        }
        return Promise.reject(err)
    }
)
// 暴露所写的内容
export default http
